export const HOME = "/";
export const SERVICES = "/services";
export const SERVICE_DETAIL = "/services/:serviceSlug";
export const SMART_STANDS = "/services/smart-stands";
export const DIGITAL_BUSINESS_CARD = "/services/digital-business-card";
export const RESTAURANT_MENUS = "/services/digital-restaurant-menu";
export const WORK = "/work";
export const GUIDES = "/guides";
export const GUIDE_DETAIL = "/guides/:guideSlug";
export const ABOUT = "/about";
export const CONTACT = "/contact";
export const PRIVACY_POLICY = "/privacy-policy";
export const TERMS = "/terms";
export const COOKIE_POLICY = "/cookie-policy";
export const SHOP = "/shop";
export const FEATURED_PRODUCTS = "/nfcprods";
export const RECOMMENDED_PRODUCTS = "/topselling";
export const ACCOUNT = "/account";
export const ACCOUNT_EDIT = "/account/edit";
export const ADMIN_DASHBOARD = "/admin/dashboard";
export const ADMIN_PRODUCTS = "/admin/products";
export const ADMIN_USERS = "/admin/users";
export const ADMIN_ACCOUNTING = "/admin/accounting";
export const ADMIN_ANALYTICS = "/admin/analytics";
export const ADD_PRODUCT = "/admin/add";
export const EDIT_PRODUCT = "/admin/edit";
export const SEARCH = "/search/:searchKey";
export const SIGNIN = "/signin";
export const SIGNOUT = "/signout";
export const SIGNUP = "/signup";
export const FORGOT_PASSWORD = "/forgot_password";
export const CHECKOUT_STEP_1 = "/checkout/step1";
export const CHECKOUT_STEP_2 = "/checkout/step2";
export const CHECKOUT_STEP_3 = "/checkout/step3";
export const VIEW_PRODUCT = "/product/:id";
export const VIEW_User = "/user/:id";
